const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
// @ actions
const blockedAccountsActions = require('actions/blockedAccounts');
const appraisalRequestAction = require('actions/mortgageRequest/mortgageRequestAppraisalRequest');
const estatesAction = require('actions/mortgageRequest/mortgageRequestInmuebles');
const paymentAction = require('actions/mortgageRequest/mortgageRequestPayment');
// @ components
const MortgageRequestAppraisalRequestStep1 = require('./mortgageRequestAppraisalRequestStep1/mortgageRequestAppraisalRequestStep1');
const MortgageRequestAppraisalRequestStep2 = require('./mortgageRequestAppraisalRequestStep2/mortgageRequestAppraisalRequestStep2');
const MortgageRequestAppraisalRequestStep3 = require('./mortgageRequestAppraisalRequestStep3/mortgageRequestAppraisalRequestStep3');
const MortgageRequestAppraisalRequestError = require('./mortgageRequestAppraisalRequestError/mortgageRequestAppraisalRequestError');
const MortgageRequestAppraisalRequestSuccess = require('./mortgageRequestAppraisalRequestSuccess/mortgageRequestAppraisalRequestSuccess');
// @ constants
const { SECOND_STEP } = require('constants/index');

class MortgageRequestAppraisalRequest extends React.Component {

    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount() {
        const { requestEstates, requestPayment } = this.props;

        requestEstates(true);
        requestPayment();
    }

    componentWillUnmount() {
        this.props.clearRequest();
    }

    handleCancel() {
        this.props.history.push('/myprofile/mortgage/panel');
    }

    render() {
        const {
            finish,
            getBlockedAccounts,
            immAccounts,
            immAppraisalRequest,
            immEstates,
            immPayment,
            resetBlockedAccounts,
            resetStep,
            setAccount,
            setTotalCost,
            setVisibleStep,
            setWillCancel,
            validateStep,
            immState
        } = this.props;

        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            resetStep,
            cancel: this.handleCancel,
            finish
        };

        const immSteps = immAppraisalRequest.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immAppraisalRequest.get('visibleStep');
        const immFinalButton = 'mortgageRequestAppraisalRequest-finalButton';
        const isFetching = immAppraisalRequest.get('inProgress');
        const isLoading = immSteps.getIn([SECOND_STEP, 'isFetching']);
        const disableNextButton = !immSteps.getIn([SECOND_STEP, 'validUI']);
        const firstStepNextButtonDisabled = immEstates.get('isFetching') || immPayment.get('isFetching');

        let content;

        if (immAppraisalRequest.get('error')) {
            content = <MortgageRequestAppraisalRequestError />;
        } else if (immAppraisalRequest.get('success')) {
            content = (
                <MortgageRequestAppraisalRequestSuccess
                    immPayment={immPayment}
                    immEstates={immEstates}
                    immAccounts={immAccounts}
                />
            );
        } else {
            content = (
                <div className="row">
                    <div className="mortgage-request-appraisal-request col-lg-11">
                        <Wizard
                            actions={actions}
                            stepsAmount={stepsAmount}
                            visibleStep={visibleStep}
                            immSteps={immSteps}
                            isFetching={isFetching}
                        >
                            <WizardStep
                                position="first"
                                cancelButton={true}
                                nextButtonDisabled={firstStepNextButtonDisabled}
                            >
                                <MortgageRequestAppraisalRequestStep1
                                    immEstates={immEstates}
                                    immPayment={immPayment}
                                />
                            </WizardStep>
                            <WizardStep
                                position="middle"
                                cancelButton={true}
                                previousButton={true}
                                nextButtonDisabled={disableNextButton}
                                isLoading={isLoading}
                            >
                                <MortgageRequestAppraisalRequestStep2
                                    getBlockedAccounts={getBlockedAccounts}
                                    immPayment={immPayment}
                                    immEstates={immEstates}
                                    immAppraisalRequest={immAppraisalRequest}
                                    immAccounts={immAccounts}
                                    resetBlockedAccounts={resetBlockedAccounts}
                                    setAccount={setAccount}
                                    setTotalCost={setTotalCost}
                                    immState={immState}
                                />
                            </WizardStep>
                            <WizardStep
                                position="last"
                                cancelButton={true}
                                previousButton={true}
                                addLoadingBehaviour={true}
                                immFinalButton={immFinalButton}
                                disablePrevious={isFetching}
                                disableCancel={isFetching}
                            >
                                <MortgageRequestAppraisalRequestStep3
                                    immPayment={immPayment}
                                    immEstates={immEstates}
                                    immAccounts={immAccounts}
                                    immState={immState}
                                />
                            </WizardStep>
                        </Wizard>
                    </div>
                </div>
            );
        }

        return content;
    }
}

MortgageRequestAppraisalRequest.propTypes = {
    clearRequest: PropTypes.func.isRequired,
    finish: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAppraisalRequest: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    requestEstates: PropTypes.func.isRequired,
    requestPayment: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setTotalCost: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    immState: PropTypes.object.isRequired
};

module.exports.MortgageRequestAppraisalRequest = connect(
    state => ({
        immAccounts: state.accounts,
        immAppraisalRequest: state.mortgageRequestAppraisalRequest,
        immEstates: state.mortgageRequestInmuebles,
        immPayment: state.mortgageRequestPayment,
        immState: state.mortgageRequestState,
    }),
    {
        clearRequest: appraisalRequestAction.clearRequest,
        finish: appraisalRequestAction.postChange,
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        requestEstates: estatesAction.requestInmuebles,
        requestPayment: paymentAction.requestPayment,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        setAccount: appraisalRequestAction.setAccount,
        setTotalCost: appraisalRequestAction.setTotalCost,
        resetStep: appraisalRequestAction.resetStep,
        setVisibleStep: appraisalRequestAction.setVisibleStep,
        setWillCancel: appraisalRequestAction.setWillCancel,
        validateStep: appraisalRequestAction.validateStep
    }
)(withRouter(MortgageRequestAppraisalRequest));
